import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ChatSearchBar from '../components/ChatSearchBar';
import { sendChatMessage } from '../services/chat';

const NewRelationshipPage = () => {
  const navigate = useNavigate();
  const { accessToken } = useAuth();
  const [chatInput, setChatInput] = useState('');
  const [chatMessages, setChatMessages] = useState([]);
  const [chatConversationId, setChatConversationId] = useState(null);
  const [chatLoading, setChatLoading] = useState(false);
  const [chatError, setChatError] = useState(null);

  const handleChatSend = (textInput) => {
    const text = (typeof textInput === 'string' ? textInput : chatInput).trim();
    if (!text || chatLoading) return;
    setChatError(null);
    setChatMessages((prev) => [...prev, { id: crypto.randomUUID(), role: 'user', content: text }]);
    setChatLoading(true);
    (async () => {
      try {
        const res = await sendChatMessage({
          message: text,
          conversationId: chatConversationId,
          accessToken,
          forceIntent: 'create_contact',
        });
        setChatConversationId((prev) => prev || res.conversation_id || null);
        
        console.log(res);
        const contactId = res?.data?.contact_id;

        if (contactId) {
          setChatMessages((prev) => [
            ...prev,
            {
              id: crypto.randomUUID(),
              role: 'assistant',
              content: 'Successfully created user.',
              type: 'success',
            },
          ]);
          navigate(`/relationship/${contactId}`);
        } else {
          const msg = 'Created contact but no contact_id returned.';
          setChatMessages((prev) => [...prev, { id: crypto.randomUUID(), role: 'assistant', content: msg, type: 'error' }]);
          setChatError(msg);
        }
      } catch (error) {
        const msg = error?.message || 'Failed to fetch chat';
        setChatMessages((prev) => [...prev, { id: crypto.randomUUID(), role: 'assistant', content: msg, type: 'error' }]);
        setChatError(msg);
      } finally {
        setChatLoading(false);
        setChatInput('');
      }
    })();
  };

const mainClass = 'flex h-full flex-1 flex-col overflow-hidden px-4 py-6 md:px-8 md:py-10 pt-16 md:pt-10';

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#050815] via-[#0a0f1f] to-[#050815] text-slate-100">
      <div className="flex flex-col md:flex-row min-h-screen w-full overflow-hidden">
        <main className={mainClass}>
          <div className="mb-6 flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-semibold text-slate-50">New Relationship</h1>
            </div>
            <button
              type="button"
              onClick={() => navigate('/relationships')}
              className="text-xl font-semibold text-slate-200 hover:text-slate-50"
            >
              ×
            </button>
          </div>

          <div className="flex flex-col flex-1 gap-4">
            <div className="flex-1 min-h-[240px] overflow-y-auto space-y-2 px-1">
              {chatMessages.length === 0 ? (
                <p className="text-sm text-slate-400">Tell Dexter about the new contact and we will map it for you.</p>
              ) : (
                <div className="space-y-2">
                  {chatMessages.map((m) => (
                    <div key={m.id} className={m.role === 'user' ? 'text-right' : 'text-left'}>
                      <p className="text-sm text-slate-100">{m.content}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {chatError ? <p className="text-xs text-amber-400">{chatError}</p> : null}
            <ChatSearchBar
              value={chatInput}
              onChange={setChatInput}
              onSubmit={() => handleChatSend(chatInput)}
              disabled={chatLoading}
              placeholder="Tell me anything about your new relationship..."
            />
          </div>
        </main>
      </div>
    </div>
  );
};

export default NewRelationshipPage;
